export default class Deactivate extends CustomEvent {
    constructor(caller) {
        super('deactivate', {
            bubbles: false,
            detail: {
                caller
            }
        });
    }
}
